import React, { useState, useRef, lazy, Suspense, useEffect } from "react";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { Cookies } from '../../../../index.js';
import CryptoJS from "crypto-js";
const LazyReCAPTCHA = lazy(() => import("../../../../app_structure/LazyReCAPTCHA"));

function Getlink(props) {
  const showcaptcha = props.data;
  const { setgtoken } = props;
  const recaptchaRef = React.createRef();
  const [nutorder, setnutorder] = useState('Confirm');

  const hcaptchaRef = useRef(null);
  const sendDataToParent = (value) => {
    // const newData = /* some data you want to send to the parent */;

    // Gọi hàm callback từ prop để truyền dữ liệu về cha
    props.sendDataToParent(value);
  };
  const handleRecaptchaChange = (value) => {
    console.log(value);
    const maxLength = 200;
    let newValue = { gtoken: value };

    sendDataToParent(newValue);
    setgtoken(value);
    if (value.length > maxLength) {
      // props.setnutxuly(1);
      // setnutorder('Bạn hãy đợi vài giây để app xử lý nhé');
      // const myCookieValue = Cookies.get('apikey');
      // let data = JSON.stringify({
      //   "recaptchaValue": value,
      //   "macode": macode,
      //   "apikey": myCookieValue
      // });
      // let config = {
      //   method: 'post',
      //   maxBodyLength: Infinity,
      //   url: 'https://hust.media/api/wallet/momoidcode.php',
      //   headers: {
      //     'Content-Type': 'application/json'
      //   },
      //   data: data
      // };
      // axios.post(config.url, config.data, config.headers)
      //   .then((response) => {
      //     props.setnutxuly(0);
      //     testFunction(response);
      //   })
      //   .catch((error) => {
      //     props.setnutxuly(0);
      //     alert_error(error);
      //   });
    }
    else {
      setnutorder('Đã xảy ra lỗi tải lại trang nhé');
    }
  };
  const handleHcaptchaVerify = (token) => {
    // console.log(token);
    // This function will be called after a user successfully completes the CAPTCHA challenge.
    // You can use the 'token' to verify on your server.

    // For now, let's just update the 'htoken' state with the token.
    // console.log(token);
    const maxLength = 200;
    // sethtoken(token);
    let newValue = { htoken: token };
    console.log(newValue);
    sendDataToParent(newValue);
    if (token.length > maxLength) {
      // setgtoken(token);
      setnutorder('Chuyển điểm ngay');
    }
    else {
      setnutorder('Đã xảy ra lỗi tải lại trang nhé');
    }
  };
  const handleSubmit = () => {
    props.setnutxuly(1);
    // console.log(4324234234);
    const myCookieValue = Cookies.get('apikey');
    var encrypted = CryptoJS.AES.encrypt(props.service + '|' + myCookieValue, "1234567")

    var data = encrypted.ciphertext.toString()
    var key = encrypted.key.toString()
    var iv = encrypted.iv.toString()
    var jsonString = {
      "data": data,
      "key": key,
      "iv": iv
    };
    // Convert to JSON string
    // var jsonString = JSON.stringify(jsonObject);

    console.log(jsonString);
    sendDataToParent(jsonString);
    if (jsonString) {
      // setgtoken(token);
      setnutorder('Please wait a moment 😊');
    }
    else {
      setnutorder('Đã xảy ra lỗi tải lại trang nhé');
    }
  };
  useEffect(() => {
    setnutorder('Confirm');
    props.setnutxuly(0);
  }, []);
  useEffect(() => {
    if (props.nutxuly == 0) {
      setnutorder('Confirm');
    }
  }, [props.nutxuly]);
  return (
    <>
      {showcaptcha ? (
        <div style={{ textAlign: "center" }} className="mt-0   justify-center items-center ">
          <button disabled={props.nutxuly == 1} onClick={handleSubmit}
            className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2  w-full dark:bg-slate-800 dark:text-white'>
            <div className='flex items-center justify-between flex-1'>
              {props.nutxuly == 1 &&
                <div className="spinner-border" role="status">

                </div>}


              <span className='text-lg font-medium text-white'>
                {nutorder} </span>
              <div className="text-xl">
                {'\u27A4'}
              </div>
            </div>
          </button>
        </div>) : (<>
          <div style={{ textAlign: "center" }} className="mt-0  flex justify-center items-center ">
            loading ..
          </div></>)}

    </>
  )
}


export default Getlink;
